import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name externalTradeService
     * @memberof app
     *
     * @description
     * Just holds the data of the external form to keep it throughout the stages of the wizard for creating external
     * trades for REMIT reporting.
     *
     * @author flzemke.btc
     */
    angular.module('app').service('externalTradeService', externalTradeService);

    function externalTradeService(): { data: ExternalTradeServiceData } {
        return {
            data: {
                runtime: { start: null, end: null },
                perspective: 'SELLER',
                procedureType: 'OTC',
                transactionType: 'ASSIGNMENT',
                capacityCategory: 'FIRM',
                gasType: 'H_GAS',
                direction: 'EXIT/ENTRY',
                capacity: {
                    unit: 'kWh/h'
                }
            }
        };
    }
})();

export interface ExternalTradeServiceData {
    runtime: { start: string | Date | null; end: string | Date | null };
    perspective: string;
    procedureType: string;
    transactionType: string;
    capacityCategory: string;
    gasType: string;
    direction: string;
    capacity: {
        unit: string;
    };
    templateName?: string;
}
